import React from 'react'
import LeagueCard from './LeagueCard'

export default function LeaguesGrid({
  leagues,
  selectedLeagueId,
  isLeagueRegistered,
  onSelect,
  onRadioKeyDown,
  radiogroupRef,
}) {
  if (leagues.length === 0) {
    return (
      <div className="no-leagues-message">
        <h2>No leagues currently open for registration</h2>
        <p>
          New leagues typically open at the start of each season. Check back
          soon or contact your league administrator for more information about
          upcoming registration dates.
        </p>
      </div>
    )
  }

  // Enabled leagues + map from league id -> enabledIdx
  const enabledLeagues = leagues.filter((l) => !isLeagueRegistered(l.id))
  const enabledIdxMap = new Map(enabledLeagues.map((l, i) => [l.id, i]))

  return (
    <div
      className="leagues-grid"
      role="radiogroup"
      aria-label="Choose a league"
      ref={radiogroupRef}
    >
      {leagues.map((league) => {
        const isAlreadyRegistered = isLeagueRegistered(league.id)
        const enabledIdx = enabledIdxMap.get(league.id)

        return (
          <LeagueCard
            key={league.id}
            league={league}
            selected={selectedLeagueId === league.id.toString()}
            disabled={isAlreadyRegistered}
            onClick={() => {
              if (!isAlreadyRegistered) onSelect(league.id.toString())
            }}
            onKeyDown={(e) => {
              // Block activation on registered items, but keep navigation working
              const k = e.key
              const isActivate =
                k === 'Enter' || k === ' ' || e.code === 'Space'
              if (isAlreadyRegistered && isActivate) {
                e.preventDefault()
                return
              }
              // Always delegate to keyboard nav; if enabledIdx is undefined (registered),
              // the hook should derive index from DOM.
              onRadioKeyDown(e, enabledIdx)
            }}
          />
        )
      })}
    </div>
  )
}
